// extracted by mini-css-extract-plugin
export default {"errCard":"errCard_errCard__7SWAH","errCardFooter":"errCard_errCardFooter__nYysa"};